import JsBarcode from 'jsbarcode';
import * as moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Form, Image } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { reduxForm } from 'redux-form';
import { CabecalhoRiachao } from '../../../components/UtilComponent';
import { formatarValorReal, formatarValorNormal } from '../../../utils/utils'
import * as Constants from '../../../utils/constants';

export const PrinterDetail = ({
    pesagemObject,
    handleCancel,
    handlePrintTermica
}) => {



    // JsBarcode("#barcode", "12345670", {format: "ean8"});
    const placa = pesagemObject.placa_carro ? pesagemObject.placa_carro.toUpperCase() : 'Sem Placa'
    const labelTitle = pesagemObject.is_ativo ? 'ENTRADA' : 'SAÍDA'
    const motorista = pesagemObject.motorista ? pesagemObject.motorista : ''
    const agricultor = pesagemObject.agricultor ? pesagemObject.agricultor.nome_completo : ''
    const produto = pesagemObject.produto ? pesagemObject.produto.descricao : ''
    const tipo_pagamento = pesagemObject.tipo_pagamento ? pesagemObject.tipo_pagamento.descricao : ''
    //TODO precisa atualizar, caso a pesagem já tenha sido finalizada, pegar o usuário finalizado
    const usuario_entrada = pesagemObject.usuario_pesagem_entrada ? pesagemObject.usuario_pesagem_entrada.username : ''
    const usuario_saida = pesagemObject.usuario_pesagem_saida ? pesagemObject.usuario_pesagem_saida.username : ''
    const servicos = pesagemObject.servicos ? pesagemObject.servicos.map((s) => {

        s.valor_total = formatarValorReal(s.valor_total);
        s.valor_adicional = formatarValorReal(s.valor_adicional);
        return s;

    }) : ''
    const columns = [{
        dataField: 'id',
        text: 'ID',
        sort: true,
    }, {
        dataField: 'descricao',
        text: 'Descricao',
        sort: true,
    },
    {
        dataField: 'valor_total',
        text: 'Valor Total',

    },
    {
        dataField: 'valor_adicional',
        text: 'Valor Adicional',
    },

    ];

    JsBarcode(".barcode").init();

    return <Form className="impressaoPesagem" style={{
        backgroundImage: `linear-gradient( rgba(255,255,255,.9) 100%,rgba(255,255,255,.9) 100%), url(${Constants.API_ROOT_URL}media/image/logo.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%, 100%"
        }} >
        <CabecalhoRiachao />
        <div id='impressao'>
            <Form.Row>
                <Col className="text-center">

                    <h3>
                        {labelTitle}
                    </h3>

                </Col>

            </Form.Row>
            

            <Form.Row>
                <Col className="text-center">
                    <svg class="barcode"
                        jsbarcode-format="code128"
                        jsbarcode-value={pesagemObject.id}
                        jsbarcode-textmargin="0"
                        jsbarcode-fontoptions="bold">
                    </svg>
                </Col>

            </Form.Row>
            <Form.Row>
                <Col className="text-center" style={{fontSize:10,color:'red'}}>
                    <span>Você deve inserir o código de barras no leitor quando voltar do carregamento para a pesagem de saída.</span>
                </Col>
            </Form.Row>
            <hr />


            <Form.Row>
                <Col className="text-center">
                    <Form.Label>
                        Peso Entrada
                        <p>{formatarValorNormal(pesagemObject.peso)} Kg</p>
                    </Form.Label>

                </Col>


                {!pesagemObject.is_ativo ?

                    <Col className="text-center">
                        <Form.Label>
                            Peso Saída
                            <p>{formatarValorNormal(pesagemObject.peso_saida)} Kg</p>
                        </Form.Label>

                    </Col>

                    :
                    ""
                }

                <Col className="text-center">
                    <h4>
                        <strong >Peso Líquido</strong>
                        <strong> <p>{formatarValorNormal(pesagemObject.peso_liquido)} Kg</p></strong>
                    </h4>

                </Col>

            </Form.Row>
            <hr />
            <Form.Row >
                <Col className="text-center">
                    <Form.Label> <strong> Data Entrada: {moment(pesagemObject.data_entrada).format('DD/MM/YYYY HH:mm')}</strong> </Form.Label>


                </Col>
            </Form.Row>

            {!pesagemObject.is_ativo ?
                <Form.Row >
                    <Col className="text-center">
                        <Form.Label><strong> Data Saída: {moment(pesagemObject.data_saida).format('DD/MM/YYYY HH:mm')}</strong></Form.Label>
                    </Col>
                </Form.Row>
                : <></>
            }
            <Form.Row>
                <Col>
                    <h4>
                        <strong>Placa: {placa}</strong>
                    </h4>
                </Col>
            </Form.Row>
            <Form.Row>
                {motorista && motorista.nome_completo ? <Col>
                    <Form.Label>
                        Transportadora: {motorista.nome_completo}
                    </Form.Label>
                </Col> : <></>
                }
                <Col>
                    <Form.Label>
                        Cliente: {agricultor}
                    </Form.Label>
                </Col>
                <Col>
                    <Form.Label>
                        Motorista: {pesagemObject.nome_motorista}
                    </Form.Label>
                </Col>



            </Form.Row>
            <Form.Row>
                <Col>
                    <Form.Label>
                        Usuário Entrada: {usuario_entrada} <br />
                        {usuario_saida ? `Usuário Saída: ${usuario_saida}` : <></>}
                    </Form.Label>
                </Col>
                <Col>
                    <Form.Label>
                        Produto: {produto}
                    </Form.Label>
                </Col>
                <Col>
                    <Form.Label>
                        Observação: {pesagemObject.observacao}
                    </Form.Label>
                </Col>
            </Form.Row>
            {/* <Form.Row>

            <Col className="text-center">
                Pagamento
            </Col>
        </Form.Row> */}
            {/* <hr /> */}
            <Form.Row>

                <Col>
                    <Form.Label>
                        Tipo Pagamento: {tipo_pagamento}
                    </Form.Label>
                </Col>
                <Col>
                    <Form.Label>
                        Valor Total: {formatarValorReal(pesagemObject.valor_total)}
                    </Form.Label>
                </Col>

                <Col>
                    <Form.Label>
                        Valor Pago: {formatarValorReal(pesagemObject.valor_pago)}
                    </Form.Label>
                </Col>
                <Col>
                    <Form.Label>
                        Troco: {formatarValorReal(pesagemObject.valor_troco)}
                    </Form.Label>
                </Col>


            </Form.Row>

            <hr />

            <Form.Row>
                <Form.Group as={Col}>
                    <BootstrapTable responsive keyField='id' data={servicos} columns={columns} bordered={false} >

                    </BootstrapTable>


                </Form.Group>
            </Form.Row>
            <Form.Row style={{ marginTop: '3rem' }}>
                <Col className="text-center">
                    ________________________________________________________ <br />
                    Ass: Balanceiro

                </Col>
                <Col className="text-center">
                    ________________________________________________________ <br />
                    Ass: Cliente

                </Col>
            </Form.Row>
        </div>

        <Form.Row>
            <Form.Group as={Col}>
                <Button variant="danger" className="noprint" onClick={() => handleCancel()} >Voltar</Button>
            </Form.Group>

            <Form.Group as={Col} className="text-md-right noprint" >
                <Button type="button" variant="info" onClick={() => handlePrintTermica()}>Impressão Térmica</Button>
            </Form.Group>

            <Form.Group as={Col} className="text-md-right noprint" >
                <Button type="button" variant="primary" onClick={() => {
                    window.print();
                }}>Impressão A4</Button>
            </Form.Group>
        </Form.Row>



    </Form >

};


PrinterDetail.propTypes = {
    pristine: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    heading: PropTypes.string.isRequired,
    handlePrint: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handlePrintTermica: PropTypes.func.isRequired,



};

export default reduxForm({
    form: 'PrinterDetail',
    enableReinitialize: true
})(PrinterDetail);



